<template>
  <model-form
    ref="modelForm"
    :model="visitReview"
    width="550px"
    modal-type="modal"
    title="Visit Review"
  >
    <div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          :model-value="visitReview.movie.name"
          class="col"
          label="Movie"
          readonly
        />
        <q-input
          :model-value="visitReview.user && visitReview.user.name"
          class="col sensitive-input"
          label="User"
          readonly
        />
        <q-input
          :model-value="visitReview.employee && visitReview.employee.name"
          class="col sensitive-input"
          label="Employee"
          readonly
        />
      </div>
      <div class="row q-gutter-md q-mb-md">
        <div class="col">
          <div>
            How would you rate the movie?
          </div>
          <div>
            <q-rating
              :model-value="visitReview.movieRating || 0"
              max="5"
              size="lg"
              color="yellow"
              icon="star_border"
              icon-selected="star"
              icon-half="star_half"
              flat
              readonly
            />
          </div>
        </div>
        <div class="col">
          <div>
            How was the staff?
          </div>
          <div>
            <q-rating
              :model-value="visitReview.staffRating || 0"
              :max="4"
              size="lg"
              color="green-5"
              flat
              :icon="RATING_ICONS"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="row q-gutter-md q-mb-md">
        <div class="col">
          <div>
            How clean was the auditorium?
          </div>
          <div>
            <q-rating
              :model-value="visitReview.cleanlinessRating || 0"
              :max="4"
              size="lg"
              color="blue-5"
              flat
              :icon="RATING_ICONS"
              readonly
            />
          </div>
        </div>
        <div class="col">
          <div>
            How was your overall experience?
          </div>
          <div>
            <q-rating
              :model-value="visitReview.overallRating || 0"
              :max="4"
              size="lg"
              color="purple-5"
              flat
              :icon="RATING_ICONS"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="row q-gutter-md q-mb-md">
        <q-input
          :model-value="visitReview.comments"
          class="col"
          label="Customer Comments"
          type="textarea"
          readonly
        />
      </div>
      <div class="row q-col-gutter-md q-mb-md">
        <div class="col-6 row items-center">
          <q-btn
            outline
            class="col"
            color="primary"
            label="Order"
            @click="$editModel(visitReview.order)"
          />
        </div>
        <div class="col-6 row items-center">
          <q-btn
            v-if="visitReview.user"
            class="col sensitive-button"
            color="primary"
            outline
            :label="visitReview.user.name"
            @click="$editModel(visitReview.user)"
          />
        </div>
      </div>
    </div>
  </model-form>
</template>

<script>

import { RATING_ICONS } from 'src/models/visit-review/VisitReview'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'VisitReviewForm',
  components: {
    ModelForm
  },
  created () {
    _.extend(this, { RATING_ICONS })
  },
  models: {
    visitReview: {
      movie: 'default',
      user: 'default',
      employee: 'default',
      order: 'default'
    }
  }
}

</script>
